import { gql } from "@apollo/client";

export const ASSETS_QUERY = gql`
  query assets($keyword: String!, $currencyId: Int!) {
    assets(keyword: $keyword, currencyId: $currencyId) {
      assetId
      assetName
      assetDisplayName
      brandName
      kindOfObjectName
      conditionTypeId
      conditionTypeName
      manufacturingYear
      operatingHours
      brandId
      priceCards {
        guid
        version
      }
    }
  }
`;

export const GET_ASSET_CONDITION_TYPES_QUERY = gql`
  query assetConditionTypes($type: String!) {
    assetConditionTypes(type: $type) {
      id
      code
      name
    }
  }
`;

export const EXCHANGE_RATE_QUERY = gql`
  query exchangeRate($fromCurrencyCode: String!, $toCurrencyCode: String!) {
    exchangeRate(fromCurrencyCode: $fromCurrencyCode, toCurrencyCode: $toCurrencyCode) {
      exchangeRate
      exchangeRateDate
    }
  }
`;
